import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Footer from "../layouts/Footer";
import Headertwo from "../layouts/Headertwo";
import Content from "../sections/home/Content";
class Home extends Component {
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>EthioFinance | Homepage</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Headertwo />
        <Content />
        <Footer />
      </Fragment>
    );
  }
}

export default Home;
